import React from "react";
import { Form, Button } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { Record } from "../../../../api";
import { useAuth } from "../../../../hooks";

const recordController = new Record();

export function RecordForm({ record, close, onReload }) {
  const { accessToken } = useAuth();

  const formik = useFormik({
    initialValues: {
      numero:   record?.numero   || "",
      nombre:   record?.nombre   || "",
      apellido: record?.apellido || "",
    },
    validationSchema: Yup.object({
      numero:   Yup.string().required("El número de record es requerido"),
      nombre:   Yup.string().required("El nombre es requerido"),
      apellido: Yup.string().required("El apellido es requerido"),
    }),
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (record) {
          await recordController.updateRecord(accessToken, record._id, values);
          toast.success("Legajo actualizado");
        } else {
          await recordController.createRecord(accessToken, values);
          toast.success("Legajo creado");
        }
        onReload();
        close();
      } catch (err) {
        toast.error(err?.msg || "Error al guardar");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit} style={{ padding: "0.5rem" }}>
      <ToastContainer position="top-center" autoClose={800} hideProgressBar />
      <Form.Input
        label={<label><span style={{ color: "#db2828" }}>* </span>N° de Legajo</label>}
        name="numero"
        value={formik.values.numero}
        onChange={formik.handleChange}
        error={formik.errors.numero}
        placeholder="Ej: 1024"
      />
      <Form.Input
        label={<label><span style={{ color: "#db2828" }}>* </span>Nombre</label>}
        name="nombre"
        value={formik.values.nombre}
        onChange={formik.handleChange}
        error={formik.errors.nombre}
        placeholder="Ej: Juan"
      />
      <Form.Input
        label={<label><span style={{ color: "#db2828" }}>* </span>Apellido</label>}
        name="apellido"
        value={formik.values.apellido}
        onChange={formik.handleChange}
        error={formik.errors.apellido}
        placeholder="Ej: Pérez"
      />
      <div style={{ display: "flex", justifyContent: "center", gap: "0.5rem", marginTop: "1rem" }}>
        <Button primary type="submit" loading={formik.isSubmitting} disabled={formik.isSubmitting}>
          {record ? "Actualizar" : "Guardar"}
        </Button>
        <Button type="button" onClick={close}>Cancelar</Button>
      </div>
    </Form>
  );
}
